module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style1/message-alert-style1.component.scss
// module id = ./src/app/features/message-alert/message-alert-style1/message-alert-style1.component.scss
// module chunks = main